
import $ from 'jquery';

var thelang = document.getElementsByTagName('html')[0].getAttribute('lang');

class Calendar{
    constructor(){
        this.containercalendar = $("#customcalendar");
        this.containercalendarvalue = "customcalendar";
        this.language = document.getElementsByTagName('html')[0].getAttribute('lang');
        this.events();        
    }
  
    // Events
    events() {       
        this.getResults(this);
    }
    
    // Methods
    getResults() {        
        var jsonurl='https://summer-schools.uoc.gr/wp-json/summerschools/v1/calendar/?type=all&language=en';
        $.getJSON(jsonurl, this.callbackFuncWithData.bind(this));        
    }

    callbackFuncWithData(json){        
        var calendarEl = document.getElementById( this.containercalendarvalue );            
        var calendar = new FullCalendar.Calendar(calendarEl, json);        
        calendar.render(); 
    }
   
}

export default Calendar;